import type { EnvironmentConfig } from './environment.types';

/**
 * INT environment configuration.
 * Used for integration testing and development.
 */
export const environment: EnvironmentConfig = {
  name: 'INT',
  production: false,
  api: {
    proxyPath: 'https://api.int.open-pay.com/merchantPanel',
    target: 'https://api.int.open-pay.com/merchantPanel',
  },
  swaggerUrl: 'https://api.int.open-pay.com/merchantPanel/swaggerJson',
};
